import { render, staticRenderFns } from "./joint-list.vue?vue&type=template&id=5f6fbe1f&scoped=true&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform&"
import script from "./joint-list.vue?vue&type=script&lang=js&"
export * from "./joint-list.vue?vue&type=script&lang=js&"
import style0 from "./joint-list.vue?vue&type=style&index=0&id=5f6fbe1f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f6fbe1f",
  null
  
)

export default component.exports